import { calculateLabelContainerSize } from "./calculateLabelContainerSize";

export default calculateLabelContainerSize;
